import BottomMenuCasino from "../components/BottomMenuCasino";
import UpperMenu from "../components/UpperMenu";

import BottomMenuBetting from "../components/BottomMenuBettings";
import GamesContainer from "../components/GamesContainer";
import CardsContainer from "../components/CardsContainer";
import NewsListPage from "../components/NewsListPage";
import SearchBar from "../components/SearchBar";
import EmptySearch from "../components/EmptySearch";
import CasinoCardsContainer from "../components/CasinoCardsContainer";
import SupportActiveSection from "../components/SupportActiveSection";
import ChatPage from "../components/ChatPage";
import supportIcon from "../img/support_icon.png"
import { useEffect, useState } from "react";
import Popup from "../components/Popup";


function MainPage({
    isLoading, handleLoaderClick, activeSubcategory, activeCategory, setActiveCategory, setActiveSubcategory, countryName,
    games, inputValue, filteredOfers, setInputValue, handleInputChange, ClearInput, casino, bettings, setCasino, setBetting,
    setIsLoading, activeCommunitySubcategory, isSupportSectionOpen, setActiveCommunitySubcategory, setSupportSectionOpen, news, phoneNumber, userId,
    userName, userImage, setPopupShowing, isPopupShowing
}) {
    useEffect(() => {
        console.log(1)
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 50);}, []) // 50ms — достаточно, чтобы React отобразил loader при необходимости

    return <div className="main-page">
        {/* Контейнер для затемнения и лоадера */}
      {isLoading && (
        <div className="loader-overlay" onClick={handleLoaderClick}>
          <div className="loader-spinner"></div>
        </div>
      )}

      {isPopupShowing && <Popup setPopupOpened={setPopupShowing}/>}
      {activeSubcategory !== 'Сообщество' &&
        (<UpperMenu activeCategory={activeCategory} setActiveCategory={setActiveCategory} setActiveSubcategory={setActiveSubcategory} countryName={countryName}/>)
      }
      

      {activeSubcategory === 'Игры' && games !== null && ( 
        <div>
          {inputValue === '' ?(
          <GamesContainer games={games}/>
          ) : (<div>
            {filteredOfers.length > 0 ? (
              <GamesContainer games={filteredOfers}/>
            ) : (
              <EmptySearch countryName={countryName}/>
            )
            }
          </div>)}
          <SearchBar inputValue={inputValue} setInputValue={setInputValue} handleInputChange={handleInputChange} ClearInput={ClearInput} countryName={countryName}/>
        </div>
      )}

      
      {activeSubcategory === 'Казино' && casino !== null&&( 
        <CasinoCardsContainer games={activeCategory === 'Казино' ? casino: bettings} setGames={activeCategory === 'Казино' ? setCasino: setBetting} activeCategory={activeCategory} setLoading = {setIsLoading}/>
      )}
      {activeSubcategory === 'Спорт' && bettings!== null &&( 
        <CardsContainer games={activeCategory === 'Казино' ? casino: bettings} setGames={activeCategory === 'Казино' ? setCasino: setBetting} activeCategory={activeCategory} setLoading = {setIsLoading}/>
      )}
      {activeSubcategory === 'Сообщество' && ( 
        activeCommunitySubcategory === 'Новости' ? (
          <NewsListPage activeCommunitySubcategory={activeCommunitySubcategory} setActiveCommunitySubcategory={setActiveCommunitySubcategory} news={news} countryName={countryName} phoneNumber={phoneNumber}/>
        ) : (<ChatPage countryName={countryName} activeCommunitySubcategory={activeCommunitySubcategory} setActiveCommunitySubcategory={setActiveCommunitySubcategory} phoneNumber={phoneNumber} userId={userId} userImage={userImage} userName={userName}/>)
      )}
      {activeSubcategory !== 'Сообщество' && 
        <div className="support-icon-rectangle" onClick={() => setSupportSectionOpen(true)}>
          <div className="support-icon-image-container">
            <img className="support-icon-image" src={supportIcon} alt='error'/>
          </div>
        </div>
      }
      {isSupportSectionOpen && <SupportActiveSection setOpenState={setSupportSectionOpen}/>}
    
      {activeCategory === 'Казино' ? (
        <BottomMenuCasino activeSubcategory={activeSubcategory} setActiveSubcategory={setActiveSubcategory} countryName={countryName} phoneNumber={phoneNumber}/>
      ) : (
        <BottomMenuBetting activeSubcategory={activeSubcategory} setActiveSubcategory={setActiveSubcategory} countryName={countryName}/>
      )}
    </div>
};

export default MainPage;